import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import LoginComponent from '../components/LoginComponent';
import MyCapsoLogo from '../components/UI/MyCapsoLogo';


class LoginPage extends React.Component {
	render() {
		return (
			<Box sx={{
				display: 'flex',
				flexDirection: 'column'
			}}>

				<Container component="main" maxWidth="xs">
					<Box sx={{ textAlign: 'center'}}>
						<MyCapsoLogo />
					</Box>
					<LoginComponent />
				</Container>
			</Box>
		);
	}
}

export default LoginPage;